const sizes = {
    xs: 20,
    sm: 40,
    md: 65,
    lg: 90,
    xl: 135,
};

export { sizes };
